// External dependencies
import { Anchor, Col, Container, Div, Row, Text } from 'atomize';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Trans } from 'gatsby-plugin-react-i18next';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Local dependencies
import { RootState } from '../../../redux/store';
import { closeBanner } from '../redux/action';

export default function DownloadAppBanner() {
  const { isBanner } = useSelector((state): RootState => state?.banner);

  const dispatch = useDispatch();

  const data = useStaticQuery(query);
  const stores = [
    {
      image: getImage(data?.googlePlayBtn),
      link: 'https://play.google.com/store/apps/details?id=kg.medcheck.app&hl=ru',
      onClick: () => {
        if (
          typeof window !== undefined &&
          process.env.NODE_ENV === 'production'
        ) {
          window.gtag('event', 'click_app_store', {
            event_name: 'click_app_store',
          });
        }
      },
    },
    {
      image: getImage(data?.appStoreBtn),
      link: 'https://apps.apple.com/kg/app/medcheck/id1578873351',
      onClick: () => {
        if (
          typeof window !== undefined &&
          process.env.NODE_ENV === 'production'
        ) {
          window.gtag('event', 'click_google_play', {
            event_name: 'click_google_play',
          });
        }
      },
    },
  ];

  return (
    <Div
      h={isBanner ? '80px' : '0px'}
      overflow="hidden"
      d={{ xs: 'none', lg: 'flex' }}
      align="center"
      bg="#6574CF"
      w="100%"
      style={{ transition: '300ms ease 0s' }}
    >
      <Container>
        <Row align="center" p={{ y: '17px' }}>
          <Col size="3" textColor="white" textWeight="700" tag="h3">
            <Trans>magazineInApp</Trans> 🥰
          </Col>
          <Col size="8">
            <Div d="flex" style={{ gap: '8px' }}>
              {stores?.map((store, index) => (
                <Div key={index} w="126px" onClick={store.onClick}>
                  <Anchor target="_blank" href={store.link}>
                    <GatsbyImage
                      image={store.image}
                      alt="store"
                      objectFit="contain"
                    />
                  </Anchor>
                </Div>
              ))}
            </Div>
          </Col>
          <Col size="1">
            <Div
              w="50px"
              h="50px"
              d="flex"
              flexDir="column"
              align="center"
              justify="center"
              onClick={() => dispatch(closeBanner())}
              cursor="pointer"
            >
              <Text
                transform="rotate(45deg) translate(2px)"
                w="30px"
                h="2px"
                tag="span"
                bg="white"
              ></Text>
              <Text
                transform="rotate(-45deg)"
                w="30px"
                h="2px"
                tag="span"
                bg="white"
              ></Text>
            </Div>
          </Col>
        </Row>
      </Container>
    </Div>
  );
}

export const query = graphql`
  query {
    googlePlayBtn: file(relativePath: { eq: "google-play-btn.png" }) {
      childImageSharp {
        gatsbyImageData
      }
    }
    appStoreBtn: file(relativePath: { eq: "app-store-btn.png" }) {
      childImageSharp {
        gatsbyImageData
      }
    }
  }
`;
